import React from 'react'

function PrivacyScreen() {
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '2rem',
      paddingBottom: '4rem',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      
    }}>
      <div style={{ maxWidth: '1200px', padding: '0 2rem', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 className="pub-h2" style={{ marginBottom: '0.5rem' }}>Polityka prywatności</h1>
          <p className="pub-small">Jak chronimy Twoje dane w SIGMA</p>
        </div>

        <div style={{
          borderRadius: '8px',
          padding: 'clamp(1.25rem, 4vw, 3rem)',
          background: '#fff', border: '1px solid var(--pub-line)',
          boxShadow: 'none'
        }}>

          <h4 style={{ fontWeight: 'bold', marginBottom: '1rem' }}>1. Administrator danych osobowych</h4>
          <p>
            Administratorem danych osobowych jest <strong>Monika Józefowska</strong>, prowadząca działalność gospodarczą pod firmą <strong>MONIKA JÓZEFOWSKA</strong>, wpisaną do Centralnej Ewidencji i Informacji o Działalności Gospodarczej (CEIDG).
          </p>
          <p><strong>Dane rejestrowe Administratora:</strong></p>
          <ul>
            <li><strong>Nazwa firmy:</strong> MONIKA JÓZEFOWSKA</li>
            <li><strong>NIP:</strong> 9970059671</li>
            <li><strong>REGON:</strong> 527997318</li>
            <li><strong>Forma prawna:</strong> osoba fizyczna prowadząca działalność gospodarczą</li>
            <li><strong>Adres:</strong> ul. Pogodna 15, 98-400 Wieruszów, woj. łódzkie</li>
            <li><strong>E-mail kontaktowy:</strong> sigmaworkmj@gmail.com</li>
          </ul>
          <p>
            Przetwarzanie danych osobowych odbywa się zgodnie z przepisami <strong>Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych – RODO)</strong> oraz ustawy o ochronie danych osobowych.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>2. Zakres przetwarzanych danych osobowych</h4>
          <p>Administrator może przetwarzać następujące kategorie danych osobowych:</p>
          <ul>
            <li><strong>Dane identyfikacyjne:</strong> imię i nazwisko</li>
            <li><strong>Dane kontaktowe:</strong> adres e-mail, numer telefonu</li>
            <li><strong>Dane adresowe:</strong> adres zamieszkania lub adres dostawy (w przypadku zakupu produktów)</li>
            <li><strong>Dane transakcyjne:</strong> historia zamówień, płatności</li>
            <li><strong>Dane techniczne:</strong> adres IP, pliki cookies, informacje o urządzeniu i przeglądarce internetowej</li>
            <li><strong>Dane podawane dobrowolnie:</strong> podczas kontaktu z Administratorem lub korzystania z formularzy kontaktowych</li>
          </ul>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>3. Cele przetwarzania danych osobowych</h4>
          <p>Dane osobowe są przetwarzane w następujących celach:</p>
          <ul>
            <li><strong>Realizacja umowy sprzedaży:</strong> przetwarzanie zamówień, dostawa produktów i usług</li>
            <li><strong>Kontakt z użytkownikiem:</strong> odpowiedzi na zapytania, obsługa klienta, rozpatrywanie reklamacji</li>
            <li><strong>Marketing bezpośredni:</strong> wysyłanie informacji handlowych i marketingowych (za zgodą użytkownika)</li>
            <li><strong>Analiza statystyczna:</strong> poprawa funkcjonalności serwisu, analiza ruchu na stronie</li>
            <li><strong>Bezpieczeństwo:</strong> zapewnienie bezpieczeństwa serwisu i ochrona przed nadużyciami</li>
            <li><strong>Wypełnienie obowiązków prawnych:</strong> rachunkowość, archiwizacja dokumentów zgodnie z przepisami prawa</li>
          </ul>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>4. Podstawy prawne przetwarzania danych</h4>
          <p>Dane osobowe przetwarzane są na podstawie następujących podstaw prawnych określonych w RODO:</p>
          <ul>
            <li><strong>Art. 6 ust. 1 lit. b RODO</strong> – przetwarzanie jest niezbędne do wykonania umowy, której stroną jest osoba, której dane dotyczą, lub do podjęcia działań na żądanie osoby, której dane dotyczą, przed zawarciem umowy (realizacja zamówień, dostawa produktów i usług)</li>
            <li><strong>Art. 6 ust. 1 lit. c RODO</strong> – przetwarzanie jest niezbędne do wypełnienia obowiązku prawnego ciążącego na administratorze (np. obowiązki podatkowe, rachunkowe)</li>
            <li><strong>Art. 6 ust. 1 lit. f RODO</strong> – przetwarzanie jest niezbędne do celów wynikających z prawnie uzasadnionych interesów realizowanych przez administratora (analiza statystyczna, bezpieczeństwo serwisu, marketing bezpośredni własnych produktów)</li>
            <li><strong>Art. 6 ust. 1 lit. a RODO</strong> – osoba, której dane dotyczą wyraziła zgodę na przetwarzanie swoich danych osobowych (marketing, newsletter)</li>
          </ul>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>5. Odbiorcy danych osobowych</h4>
          <p>
            Dane osobowe mogą być przekazywane wyłącznie zaufanym podmiotom współpracującym z Administratorem w zakresie niezbędnym do realizacji usług. Odbiorcy danych to:
          </p>
          <ul>
            <li><strong>Dostawcy usług IT:</strong> firmy zapewniające hosting, utrzymanie i bezpieczeństwo serwisu</li>
            <li><strong>Operatorzy płatności:</strong> PayU S.A. – w celu realizacji transakcji płatniczych</li>
            <li><strong>Dostawcy usług analitycznych:</strong> Google Analytics – w celu analizy ruchu na stronie</li>
            <li><strong>Firmy kurierskie i pocztowe:</strong> w celu dostarczenia zamówionych produktów</li>
            <li><strong>Dostawcy usług marketingowych:</strong> w przypadku prowadzenia kampanii reklamowych (za zgodą użytkownika)</li>
            <li><strong>Organy państwowe:</strong> w przypadkach wymaganych przez prawo (np. organy podatkowe, sądy)</li>
          </ul>
          <p>
            <strong>Dane osobowe nie są sprzedawane osobom trzecim.</strong> Wszyscy odbiorcy danych zobowiązani są do zachowania poufności i przetwarzania danych zgodnie z obowiązującymi przepisami.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>6. Przekazywanie danych do państw trzecich</h4>
          <p>
            W związku z korzystaniem z narzędzi analitycznych (Google Analytics), dane osobowe mogą być przekazywane do państw trzecich, w tym do Stanów Zjednoczonych. Przekazywanie danych odbywa się na podstawie odpowiednich zabezpieczeń, takich jak standardowe klauzule umowne zatwierdzone przez Komisję Europejską.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>7. Czas przechowywania danych osobowych</h4>
          <p>Dane osobowe są przechowywane przez okres:</p>
          <ul>
            <li><strong>Realizacja umowy:</strong> do czasu zakończenia świadczenia usług lub dostawy produktów oraz przez okres niezbędny do dochodzenia roszczeń (zazwyczaj do czasu przedawnienia roszczeń)</li>
            <li><strong>Obowiązki prawne:</strong> przez okres wymagany przepisami prawa (np. rachunkowość – 5 lat)</li>
            <li><strong>Marketing (zgoda):</strong> do momentu wycofania zgody przez użytkownika</li>
            <li><strong>Uzasadniony interes administratora:</strong> do czasu wniesienia sprzeciwu przez użytkownika lub ustania tego interesu</li>
          </ul>
          <p>
            Po upływie okresu przechowywania dane osobowe są bezpiecznie usuwane lub anonimizowane.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>8. Prawa osób, których dane dotyczą</h4>
          <p>Użytkownik ma prawo do:</p>
          <ul>
            <li><strong>Dostępu do swoich danych osobowych</strong> – uzyskania informacji o tym, jakie dane są przetwarzane oraz otrzymania kopii tych danych</li>
            <li><strong>Sprostowania (poprawiania) danych</strong> – żądania poprawienia nieprawidłowych lub uzupełnienia niekompletnych danych</li>
            <li><strong>Usunięcia danych</strong> („prawo do bycia zapomnianym") – żądania usunięcia danych, jeśli nie ma już podstaw prawnych do ich przetwarzania</li>
            <li><strong>Ograniczenia przetwarzania</strong> – żądania ograniczenia przetwarzania danych w określonych sytuacjach (np. zakwestionowanie prawidłowości danych)</li>
            <li><strong>Przenoszenia danych</strong> – otrzymania swoich danych w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego oraz żądania przesłania tych danych innemu administratorowi</li>
            <li><strong>Wniesienia sprzeciwu</strong> – wniesienia sprzeciwu wobec przetwarzania danych z przyczyn związanych ze szczególną sytuacją użytkownika (dotyczy przetwarzania na podstawie uzasadnionego interesu administratora)</li>
            <li><strong>Cofnięcia zgody</strong> – wycofania zgody na przetwarzanie danych w dowolnym momencie (nie wpływa to na zgodność z prawem przetwarzania dokonanego przed wycofaniem zgody)</li>
            <li><strong>Wniesienia skargi do organu nadzorczego</strong> – wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (PUODO) w przypadku uznania, że przetwarzanie danych narusza przepisy RODO</li>
          </ul>
          <p>
            <strong>Kontakt w sprawie realizacji praw:</strong><br />
            E-mail: <strong>sigmaworkmj@gmail.com</strong><br />
            Adres korespondencyjny: <strong>ul. Pogodna 15, 98-400 Wieruszów</strong>
          </p>
          <p>
            Administrator odpowie na żądanie użytkownika bez zbędnej zwłoki, nie później jednak niż w ciągu miesiąca od jego otrzymania. W razie potrzeby termin ten może zostać przedłużony o kolejne dwa miesiące z uwagi na skomplikowany charakter żądania lub liczbę żądań.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>9. Pliki cookies i technologie śledzące</h4>
          <p>
            Serwis wykorzystuje pliki cookies oraz podobne technologie w następujących celach:
          </p>
          <ul>
            <li><strong>Cookies niezbędne:</strong> zapewnienie prawidłowego działania serwisu, uwierzytelnianie użytkowników (token JWT przechowywany w localStorage)</li>
            <li><strong>Cookies analityczne (Google Analytics):</strong> analiza ruchu na stronie, zachowania użytkowników oraz poprawa doświadczenia użytkownika. Te cookies są zarządzane przez Google i wysyłają anonimowe dane analityczne</li>
            <li><strong>Cookies funkcjonalne:</strong> zapamiętywanie preferencji użytkownika (np. wybór języka)</li>
          </ul>
          <p>
            <strong>Zarządzanie cookies:</strong>
          </p>
          <p>
            Użytkownik może zarządzać plikami cookies poprzez:
          </p>
          <ul>
            <li>Ustawienia przeglądarki internetowej – większość przeglądarek domyślnie akceptuje cookies, ale użytkownik może zmienić te ustawienia, aby blokować cookies lub otrzymywać powiadomienie o ich wysyłaniu</li>
            <li>Odrzucenie cookies w banerze Cookie Consent wyświetlanym przy pierwszej wizycie na stronie</li>
            <li>Wyłączenie śledzenia w Google Analytics za pośrednictwem <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">dodatku Google Analytics Opt-out Browser Add-on</a></li>
          </ul>
          <p>
            <strong>Zgoda na cookies:</strong>
          </p>
          <p>
            Przy pierwszej wizycie na stronie pojawia się baner informujący o wykorzystywaniu plików cookies. Akceptując cookies, użytkownik wyraża zgodę na ich wykorzystanie do celów analitycznych. Zgoda ta może zostać w każdej chwili wycofana poprzez zmianę ustawień przeglądarki lub kontakt z Administratorem.
          </p>
          <p>
            <strong>localStorage:</strong>
          </p>
          <p>
            Serwis wykorzystuje mechanizm localStorage do przechowywania danych niezbędnych do działania aplikacji, takich jak token uwierzytelniania (JWT) oraz preferencje użytkownika. Dane te są przechowywane lokalnie w przeglądarce użytkownika i nie są automatycznie przesyłane na serwer.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>10. Zabezpieczenia danych osobowych</h4>
          <p>
            Administrator stosuje odpowiednie środki techniczne i organizacyjne w celu ochrony danych osobowych przed nieuprawnionym dostępem, utratą, zniszczeniem lub modyfikacją. Środki te obejmują:
          </p>
          <ul>
            <li><strong>Szyfrowanie SSL/TLS:</strong> zabezpieczenie transmisji danych między przeglądarką użytkownika a serwerem</li>
            <li><strong>Zabezpieczenia serwera:</strong> regularne aktualizacje oprogramowania, firewall, monitoring bezpieczeństwa</li>
            <li><strong>Ograniczenie dostępu:</strong> dostęp do danych mają tylko upoważnione osoby, które zobowiązane są do zachowania poufności</li>
            <li><strong>Kopie zapasowe:</strong> regularne tworzenie kopii zapasowych w celu zabezpieczenia danych przed utratą</li>
            <li><strong>Procedury bezpieczeństwa:</strong> wdrożenie procedur reagowania na incydenty bezpieczeństwa</li>
          </ul>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>11. Zautomatyzowane podejmowanie decyzji i profilowanie</h4>
          <p>
            Administrator nie podejmuje zautomatyzowanych decyzji, w tym nie stosuje profilowania w rozumieniu art. 22 RODO, które wywołują skutki prawne wobec użytkownika lub w podobny sposób istotnie wpływają na użytkownika.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>12. Kontakt w sprawie ochrony danych osobowych</h4>
          <p>
            W przypadku pytań dotyczących przetwarzania danych osobowych, realizacji praw użytkownika lub jakichkolwiek wątpliwości związanych z polityką prywatności, prosimy o kontakt:
          </p>
          <p>
            <strong>E-mail:</strong> sigmaworkmj@gmail.com<br />
            <strong>Adres korespondencyjny:</strong> ul. Pogodna 15, 98-400 Wieruszów
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>13. Zmiany w polityce prywatności</h4>
          <p>
            Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności. O wszelkich zmianach użytkownicy będą informowani poprzez publikację zaktualizowanej wersji na stronie internetowej serwisu. Zmiany wchodzą w życie w dniu ich publikacji, chyba że Administrator określi inny termin.
          </p>
          <p>
            Zachęcamy do regularnego sprawdzania treści Polityki Prywatności w celu bycia na bieżąco z informacjami o tym, jak chronimy dane osobowe.
          </p>

          <p style={{ marginTop: '2rem', color: '#666', fontSize: '0.9rem' }}><small>Data ostatniej aktualizacji: 2025 rok</small></p>

        </div>
      </div>
    </div>
  )
}

export default PrivacyScreen